import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

interface Props {
  conteudoNome: string;
  onConcluir: () => void;
  onPular: () => void;
}

export function AvisoConcluirConteudo({ conteudoNome, onConcluir, onPular }: Props) {
  return (
    <div className="space-y-6 py-4">
      <div className="flex flex-col items-center text-center gap-3">
        <div className="p-3 rounded-full bg-primary/10">
          <CheckCircle2 className="h-10 w-10 text-primary" />
        </div>
        <div className="space-y-1">
          <h3 className="text-xl font-semibold text-foreground">
            Sessão registrada!
          </h3>
          <p className="text-sm text-muted-foreground max-w-md">
            Deseja marcar <span className="font-medium text-foreground">{conteudoNome}</span> como concluído?
          </p>
        </div>
      </div>

      <div className="rounded-lg border border-border bg-muted/30 p-4 text-xs text-muted-foreground">
        Marcar como concluído ajuda a acompanhar o progresso da disciplina.
        As revisões já agendadas continuam ativas mesmo assim.
      </div>

      <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
        <Button variant="outline" onClick={onPular} className="sm:flex-1">
          Agora não
        </Button>
        <Button onClick={onConcluir} className="sm:flex-1">
          Sim, marcar como concluído
        </Button>
      </div>
    </div>
  );
}
